export enum CookiesKeysEnum {
    BANNED_USER_ID = 'banned-user-id',
    /** Self-generated anonymous id for pre-registration tracking. Shared by Customer.io (AC-613) and Mixpanel (AC-711). */
    ANONYMOUS_ID = 'anonymous_id',
    /**
     * Cookie-consent decision — a versioned JSON category record
     * (`{v, necessary, analytics, marketing}`), not a boolean. Absent or
     * unparseable means "not yet asked" and the banner is shown.
     * See lib/analytics/consent.ts (AC-711).
     */
    COOKIE_CONSENT = 'cookie-consent',
    /**
     * Locale pin, owned and written by next-intl's middleware. It takes priority
     * over `Accept-Language`, so it must only ever hold a locale the visitor
     * actually signalled — see proxy.ts (AC-655). The one place we write it
     * ourselves is an explicit language switch (`persistLocaleChoice`).
     */
    NEXT_LOCALE = 'NEXT_LOCALE',
}
